/**
 * 권한/capability/category 체크 순수 함수.
 *
 * ⚠️ 보안 주의 (TODO — 다음 PR에서 반드시 처리):
 * 여기서의 메뉴 숨김·라우트 차단은 UX용일 뿐이다. 프론트 코드는 사용자가 변조할 수 있으므로
 * 실제 보안은 백엔드 API가 요청마다 session의 permission을 검증해야 한다.
 * backend permission 연동 PR에서 API 레벨 검증과 함께 이 shape를 실제 세션으로 교체한다.
 */

/** session의 store category가 item의 categories 조건을 충족하는가 (categories 미지정 = 모든 업종 공통) */
export function matchesCategory(session, item) {
  if (!item.categories || item.categories.length === 0) return true;
  return item.categories.includes(session?.store?.category);
}

/** 특정 지점 원천(예: ModernWash 전주점 JJ001)의 메뉴 노출 범위. */
export function matchesStoreCode(session, item) {
  if (!item.storeCodes || item.storeCodes.length === 0) return true;
  return item.storeCodes.includes(session?.store?.code);
}

/** store가 요구 capability를 모두 갖고 있는가 */
export function hasCapabilities(session, required = []) {
  if (required.length === 0) return true;
  const capabilities = session?.store?.capabilities || [];
  return required.every((c) => capabilities.includes(c));
}

/** session이 요구 permission을 모두 갖고 있는가 */
export function hasPermissions(session, required = []) {
  if (required.length === 0) return true;
  const permissions = session?.permissions || [];
  return required.every((p) => permissions.includes(p));
}

/**
 * 메뉴/라우트 노출 조건: category 일치 + requiredCapabilities 충족 + requiredPermissions 충족
 */
export function canAccessItem(session, item) {
  if (!session || !item) return false;
  return (
    matchesCategory(session, item) &&
    matchesStoreCode(session, item) &&
    hasCapabilities(session, item.requiredCapabilities || []) &&
    hasPermissions(session, item.requiredPermissions || [])
  );
}
